import accountSaga from './Account/saga';
import { all } from 'redux-saga/effects';
import campaignSaga from './Campaign/saga';
import configSaga from './Config/saga';
import configurationSaga from './Configuration/saga';
import coverageSaga from './Coverage/saga';
import dashboardSaga from './Dashboard/saga';
import fileSaga from './File/saga';
import officeSaga from './Office/saga';
import optionSaga from './Option/saga';
import patientSaga from './Patient/saga';
import professionalSaga from './Professional/saga';
import sharedSaga from './Shared/saga';
import statisticsSaga from './Statistics/saga';
import turnsSaga from './Turns/saga';
import userSaga from './User/saga';
import videoconferenceSaga from './Videoconference/saga';

export const getSagas = () => [
    ...accountSaga,
    ...campaignSaga,
    ...configSaga,
    ...configurationSaga,
    ...coverageSaga,
    ...dashboardSaga,
    ...fileSaga,
    ...officeSaga,
    ...optionSaga,
    ...patientSaga,
    ...professionalSaga,
    ...sharedSaga,
    ...statisticsSaga,
    ...turnsSaga,
    ...userSaga,
    ...videoconferenceSaga
];

function* rootSagas () {
    yield all(getSagas());
}

export default rootSagas;
